var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgG1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 72,
    viewBox: "0 0 70 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.0537 33.174C50.2571 -6.88488 38.1635 45.5179 38.1635 45.5179L34.2227 70.8725L49.1986 64.8513C49.1986 64.8513 49.99 45.716 50.0537 33.174Z",
    fill: "#6FCF97"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0537 33.174C50.2571 -6.88488 38.1635 45.5179 38.1635 45.5179L34.2227 70.8725L49.1986 64.8513C49.1986 64.8513 49.99 45.716 50.0537 33.174Z",
    fill: "#6FCF97"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0537 33.174C50.2571 -6.88488 38.1635 45.5179 38.1635 45.5179L34.2227 70.8725L49.1986 64.8513C49.1986 64.8513 49.99 45.716 50.0537 33.174Z",
    fill: "#6FCF97"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0537 33.174C50.2571 -6.88488 38.1635 45.5179 38.1635 45.5179L34.2227 70.8725L49.1986 64.8513C49.1986 64.8513 49.99 45.716 50.0537 33.174Z",
    fill: "#6FCF97"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4326 41.6047C79.5649 4.51328 48.7959 48.622 48.7959 48.622L35.6813 70.6763H51.8224C51.8224 70.6763 59.6948 53.2175 64.4326 41.6047Z",
    fill: "#6FCF97"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4326 41.6047C79.5649 4.51328 48.7959 48.622 48.7959 48.622L35.6813 70.6763H51.8224C51.8224 70.6763 59.6948 53.2175 64.4326 41.6047Z",
    fill: "#6FCF97"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4326 41.6047C79.5649 4.51328 48.7959 48.622 48.7959 48.622L35.6813 70.6763H51.8224C51.8224 70.6763 59.6948 53.2175 64.4326 41.6047Z",
    fill: "#6FCF97"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4326 41.6047C79.5649 4.51328 48.7959 48.622 48.7959 48.622L35.6813 70.6763H51.8224C51.8224 70.6763 59.6948 53.2175 64.4326 41.6047Z",
    fill: "#6FCF97"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.62661 23.889C-17.3329 -35.8049 31.3846 35.1825 31.3846 35.1825L52.1495 70.6762H26.5928C26.5928 70.6762 14.128 42.5785 6.62661 23.889Z",
    fill: "#6FCF97"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.62661 23.889C-17.3329 -35.8049 31.3846 35.1825 31.3846 35.1825L52.1495 70.6762H26.5928C26.5928 70.6762 14.128 42.5785 6.62661 23.889Z",
    fill: "#6FCF97"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M6.62661 23.889C-17.3329 -35.8049 31.3846 35.1825 31.3846 35.1825L52.1495 70.6762H26.5928C26.5928 70.6762 14.128 42.5785 6.62661 23.889Z",
    fill: "#6FCF97"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M6.62661 23.889C-17.3329 -35.8049 31.3846 35.1825 31.3846 35.1825L52.1495 70.6762H26.5928C26.5928 70.6762 14.128 42.5785 6.62661 23.889Z",
    fill: "#6FCF97"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgG1);
export default __webpack_public_path__ + "static/media/g1.26a0886e.svg";
export { ForwardRef as ReactComponent };